import { useQuery } from '@tanstack/react-query'
import { getContacts } from '@/lib/apiClients/inquiry'
import { queryKeys } from '@/lib/queryKeys'

export function useContacts(salesforceCustomerId?: number) {
  return useQuery({
    queryKey: queryKeys.contacts(salesforceCustomerId),
    queryFn: async () => {
      return getContacts(salesforceCustomerId)
    },
    enabled: salesforceCustomerId !== undefined,
  })
}
